const header = {
	init() {
		if (document.querySelector('.js-header')) {
			header.toggleMobileMenu();
			header.toggleMobileMenuTopSections();
			header.displayHeadlines();
			header.desktopMegaMenu();
			header.desktopMegaMenuSubMenus();
			header.autoHide();
		}
	},
	toggleMobileMenu() {
		const header = document.querySelector('.header');
		const headerMenu = document.querySelector('.header-menu');
		const headerNav = document.querySelector('.header-menu__nav');
		const headerBtn = document.querySelector('.header-menu__toggle');

		headerBtn.addEventListener('click', () => {
			header.classList.toggle('is-active');
			headerNav.classList.toggle('is-active');
			headerBtn.classList.toggle('is-active');
			headerMenu.classList.toggle('has-link-active');
		});
	},
	toggleMobileMenuTopSections() {
		const dropdownLink = document.querySelectorAll('.header-menu__menus.is-mobile .header-menu__link.has-menu');
		const subMenus = document.querySelectorAll('.header-menu__menus.is-mobile .header-menu__sub-menu');

		dropdownLink.forEach(link => {
			const subMenu = link.querySelector('.header-menu__sub-menu');
			const linkDestination = link.querySelector('a:not(.header-menu__sub-menu a)');

			link.setAttribute('aria-expanded', false);
			linkDestination.addEventListener('click', (e) => {
				e.preventDefault();
			});

			function setLinkInactive() {
				link.classList.remove('is-active');
				link.setAttribute('aria-expanded', false);
				subMenus.forEach(subMenu => {
					subMenu.classList.remove('is-active');
				});
				linkDestination.classList.remove('is-active');
			}

			function setLinkActive() {
				dropdownLink.forEach(link => {
					link.classList.remove('is-active');
					link.setAttribute('aria-expanded', false);
				});
				subMenus.forEach(subMenu => {
					subMenu.classList.remove('is-active');
				});
				link.classList.add('is-active');
				subMenu.classList.add('is-active');
				link.setAttribute('aria-expanded', true);
				linkDestination.classList.add('is-active');
			}

			linkDestination.addEventListener('click', () => {
				if (link.classList.contains('is-active')) {
					setLinkInactive();
				} else {
					setLinkActive();
				}
			});

			linkDestination.addEventListener('keyup', function (e) {
				if (e.keyCode === 27) {
					setLinkInactive();
				}
			});

		});

	},
	displayHeadlines() {
		function displayHeadlinesDesktop() {
			const headlineMaterials = document.querySelector('.header-menu__menus.is-desktop .header-menu__sub-menu-section-title.is-headline-material-families');
			if (headlineMaterials) { headlineMaterials.classList.add('is-display-active'); }

			const headlineSoftware = document.querySelector('.header-menu__menus.is-desktop .header-menu__sub-menu-section-title.is-headline-software');
			if (headlineSoftware) { headlineSoftware.classList.add('is-display-active'); }

			const headlineHardware = document.querySelector('.header-menu__menus.is-desktop .header-menu__sub-menu-section-title.is-headline-hardware');
			if (headlineHardware) { headlineHardware.classList.add('is-display-active'); }
		}
		function displayHeadlinesMobile() {
			const headlineMaterials = document.querySelector('.header-menu__menus.is-mobile .header-menu__sub-menu-section-title.is-headline-material-families');
			if (headlineMaterials) { headlineMaterials.classList.add('is-display-active'); }

			const headlineSoftware = document.querySelector('.header-menu__menus.is-mobile .header-menu__sub-menu-section-title.is-headline-software');
			if (headlineSoftware) { headlineSoftware.classList.add('is-display-active'); }

			const headlineHardware = document.querySelector('.header-menu__menus.is-mobile .header-menu__sub-menu-section-title.is-headline-hardware');
			if (headlineHardware) { headlineHardware.classList.add('is-display-active'); }
		}
		displayHeadlinesDesktop();
		displayHeadlinesMobile();
	},
	desktopMegaMenu() {
		const dropdownLink = document.querySelectorAll('.header-menu__menus.is-desktop .header-menu__link.has-menu');
		const header = document.querySelector('.header-menu');

		dropdownLink.forEach(link => {
			const subMenu = link.querySelector('.header-menu__sub-menu');
			const linkDestination = link.querySelector('a:not(.header-menu__sub-menu a)');

			link.setAttribute('aria-expanded', false);
			linkDestination.addEventListener('click', (e) => {
				e.preventDefault();
			});

			function setLinkInactive() {
				link.classList.remove('is-active');
				subMenu.classList.remove('is-active');
				link.setAttribute('aria-expanded', false);
				header.classList.remove('has-link-active');
				linkDestination.classList.remove('is-active');
			}

			function setLinkActive() {
				dropdownLink.forEach(link => {
					setLinkInactive();
				});
				link.classList.add('is-active');
				subMenu.classList.add('is-active');
				link.setAttribute('aria-expanded', true);
				header.classList.add('has-link-active');
				linkDestination.classList.add('is-active');
			}

			link.addEventListener('mouseover', () => {
				setLinkActive();
			});

			link.addEventListener('mouseout', () => {
				setLinkInactive();
			});

			linkDestination.addEventListener('keyup', function (e) {
				if (e.keyCode === 13) {
					if (link.classList.contains('is-active')) {
						setLinkInactive();
					} else {
						setLinkActive();
					}
				}
				if (e.keyCode === 27) {
					setLinkInactive();
				}
			});

		});
	},
	desktopMegaMenuSubMenus() {
		let detailLinks = document.querySelectorAll('.header-menu__menus.is-desktop .header-menu__sub-menu-link');
		let detailMenus = document.querySelectorAll('.header-menu__menus.is-desktop .sub-menu__detail');

		detailLinks.forEach(link => {
			const linkDestination = link.getAttribute('data-link-section');

			function setLinkActive() {
				const parentMenu = link.closest('.header-menu__sub-menu');
				let detailSubMenus = parentMenu.querySelectorAll('.header-menu__menus.is-desktop .sub-menu__detail');

				detailSubMenus.forEach(detailMenu => {
					detailMenu.classList.remove('is-active');
					if (linkDestination === detailMenu.getAttribute('data-menu-section')) {
						detailMenu.classList.remove('is-active');
					};
					detailMenu.setAttribute('aria-expanded', false);
				});

				detailLinks.forEach(detailLink => {
					detailLink.classList.remove('is-active');
				});

				link.classList.add('is-active');
				detailMenus.forEach(detailMenu => {
					if (linkDestination === detailMenu.getAttribute('data-menu-section')) {
						detailMenu.classList.add('is-active');
					};
				});
				link.setAttribute('aria-expanded', true);
			}

			function setLinkInactive() {
				const parentMenu = link.closest('.header-menu__sub-menu');
				let detailSubMenus = parentMenu.querySelectorAll('.header-menu__menus.is-desktop .sub-menu__detail');

				detailSubMenus.forEach(detailMenu => {
					detailMenu.classList.remove('is-active');
					detailMenu.setAttribute('aria-expanded', false);
				});

				link.classList.remove('is-active');
				link.setAttribute('aria-expanded', false);
			}

			link.addEventListener('mouseover', () => {
				setLinkActive();
			});

			link.addEventListener('keyup', function (e) {
				if (e.keyCode === 13) {
					setLinkActive();
				}
			});
		});
	},
	autoHide() {
		const el_autohide = document.querySelector('.auto-hide');
		const navbar_height = document.querySelector('.header').offsetHeight;
		const teamDMHeight = document.querySelector('.team-dm-dropdown-bar').offsetHeight;
		const teamDMDrawerHeight = document.querySelector('.team-dm-dropdown-drawer-wrapper').offsetHeight;
		const teamDMToggleCheckbox = document.querySelector('#team-dm-dropdown-toggle');

		document.body.style.paddingTop = navbar_height + teamDMHeight + 'px';

		if (el_autohide){
			var last_scroll_top = 0;
			window.addEventListener('scroll', function() {
				let scroll_top = window.scrollY;

				if (scroll_top <= 0) {
					el_autohide.classList.remove('scrolled-down');
					el_autohide.classList.add('scrolled-up');
					el_autohide.classList.add('is-top');
				}
				else if(scroll_top < last_scroll_top) {
					el_autohide.classList.remove('scrolled-down');
					el_autohide.classList.remove('is-top');
					el_autohide.classList.add('scrolled-up');
				}
				else {
					el_autohide.classList.remove('scrolled-up');
					el_autohide.classList.remove('is-top');
					el_autohide.classList.add('scrolled-down');

					// @DEV Close Team DM Nav if open
					if (teamDMToggleCheckbox.checked) {
						// Mobile version (long/needs to scroll)
						if (window.innerWidth <= 1023 ) {

							if ( scroll_top > (teamDMDrawerHeight) ) {
								teamDMToggleCheckbox.click();
							}
						} else {
							teamDMToggleCheckbox.click();
						}
					}
				}
				last_scroll_top = scroll_top;
			});
		}

		document.querySelectorAll('.dropdown-menu').forEach(function(element) {
			element.addEventListener('click', function(e) {
				e.stopPropagation();
			});
		})
	}
};

export default header.init();
